import React from 'react';
import {GatsbyImage, getImage} from "gatsby-plugin-image";
import styled, {css} from "styled-components";
import Bubbles from '../../assets/phone-bubbles-cyan.svg';
import {devices} from "../../styles/devices";
import Mask from "../../images/squircle.svg";
import media from "../../styles/media";


const Stage = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const NormalImage = styled(GatsbyImage)`
  max-height: inherit;
`;

const RoundedImage = styled(GatsbyImage)`
  max-height: inherit;
  border-radius: 40px;
  overflow: hidden;
  max-width: 100%;
`;

const SquircleImage = styled(GatsbyImage)`
  max-height: inherit;
  aspect-ratio: 1;
  -webkit-mask-image: url(${Mask});
  -webkit-mask-size: cover;
  mask-image: url(${Mask});
  mask-size: cover;

  ${media.from.tablet(css`
    position: absolute;
  `)}
`;

const StyledVector = styled.img`
  width: 100%;
  max-height: inherit;
  object-fit: contain;
`;

const Background = ({style, color, ...props}) => {
  switch (style) {
    case 'bubbles':
      return <Bubbles {...props}/>
    default:
      return <></>
  }
}

const StyledBackground = styled(Background)`
  display: none;

  @media ${devices.mobileL} {
    display: block;
    position: absolute;
    width: 100%;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(-40%);
  }
`;


const Media = ({alt, style, image, vector, background, className}) => {
  let GatsbyImageElement = RoundedImage;
  switch (style) {
    case 'squircle':
      GatsbyImageElement = SquircleImage;
      break;
    case 'square':
      GatsbyImageElement = NormalImage;
      break;
  }
  return (
    <Stage className={className}>
      {background && <StyledBackground {...background} />}
      {image && <GatsbyImageElement alt={alt} image={getImage(image)}/>}
      {vector && <StyledVector alt={alt} width="400" height="300" src={vector.publicURL}/>}
    </Stage>
  )
}

export default Media
